var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "line icons",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.185 67.414h-26.37a1 1 0 0 1 -1-1v-13.328a1 1 0 0 1 1-1h26.37a1 1 0 0 1 1 1v13.328a1 1 0 0 1 -1 1zm-25.37-2h24.37v-11.328h-24.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54.627 72h-35.254a1 1 0 0 1 -1-1v-4.586a1 1 0 0 1 1-1h35.254a1 1 0 0 1 1 1v4.586a1 1 0 0 1 -1 1zm-34.254-2h33.254v-2.586h-33.254z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37 40.99c-10.025 0-18.181-12.921-18.181-28.8a44.362 44.362 0 0 1 .991-9.4 1 1 0 0 1 .977-.79h32.426a1 1 0 0 1 .977.788 44.362 44.362 0 0 1 .991 9.4c0 15.881-8.156 28.802-18.181 28.802zm-15.4-36.99a42.647 42.647 0 0 0 -.782 8.187c0 14.779 7.259 26.8 16.181 26.8s16.181-12.024 16.181-26.8a42.647 42.647 0 0 0 -.78-8.187z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34.542 49.735h-.077a1 1 0 0 1 -.921-1.073 16.8 16.8 0 0 0 -1.857-9.139 1 1 0 0 1 1.77-.933 18.811 18.811 0 0 1 2.081 10.225 1 1 0 0 1 -.996.92z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.458 49.735a1 1 0 0 1 -1-.923 18.811 18.811 0 0 1 2.081-10.225 1 1 0 0 1 1.77.933 16.8 16.8 0 0 0 -1.857 9.139 1 1 0 0 1 -.921 1.073z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m45.658 54.086a1 1 0 0 1 -.974-.778c-.484-2.124-3.857-3.787-7.684-3.787s-7.2 1.663-7.684 3.787a1 1 0 1 1 -1.95-.443c.7-3.1 4.754-5.344 9.634-5.344s8.932 2.248 9.634 5.344a1 1 0 0 1 -.976 1.221z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.353 32a1.083 1.083 0 0 1 -.127-.008 14.888 14.888 0 0 1 -12.973-14.75v-6.942a5.12 5.12 0 0 1 5.111-5.118h3.86a1 1 0 0 1 0 2h-3.86a3.118 3.118 0 0 0 -3.111 3.118v6.939a12.883 12.883 0 0 0 11.225 12.761 1 1 0 0 1 -.125 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m49.647 32a1 1 0 0 1 -.125-2 12.883 12.883 0 0 0 11.225-12.761v-6.939a3.118 3.118 0 0 0 -3.111-3.118h-3.86a1 1 0 0 1 0-2h3.86a5.12 5.12 0 0 1 5.111 5.118v6.939a14.888 14.888 0 0 1 -12.973 14.75 1.083 1.083 0 0 1 -.127.011z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.2064d2caa4d9d6899b9e869aca8f551e.svg";
export { ForwardRef as ReactComponent };